import { useQuery } from "react-query";
import { api } from "../api";

export const useGetCustomClothes = (customTripId: number | undefined) => {
  return useQuery([customTripId], () => api.getCustomClothes(customTripId), {
    enabled: !!customTripId,
  });
};
